import { User } from "./user";

export class TabSubmissionComment {
    id!: number;
    user!: User;
    text!: string;
    created_at!: string;
    created_at_date!: Date;
    updated_at!: string;
    updated_at_date!: Date;

    static fromObject(obj: Record<string, any>): TabSubmissionComment {
        const comment = Object.setPrototypeOf(obj, TabSubmissionComment.prototype);
        comment.user = User.fromObject(comment.user);
        comment.created_at_date = new Date(comment.created_at);
        comment.updated_at_date = new Date(comment.updated_at);
        return comment;
    }
}
